const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"] as const;

interface LocalParts {
  year: number;
  month: number;
  day: number;
  hour: number;
  minute: number;
}

const partsFormat = new Intl.DateTimeFormat("en-GB", {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
});

function localParts(date: Date): LocalParts {
  const out: LocalParts = { year: 0, month: 1, day: 1, hour: 0, minute: 0 };
  for (const part of partsFormat.formatToParts(date)) {
    if (part.type === "year") out.year = Number(part.value);
    if (part.type === "month") out.month = Number(part.value);
    if (part.type === "day") out.day = Number(part.value);
    if (part.type === "hour") out.hour = Number(part.value);
    if (part.type === "minute") out.minute = Number(part.value);
  }
  return out;
}

const pad = (n: number) => String(n).padStart(2, "0");
const monthName = (month: number) => MONTHS[month - 1] ?? "";

export function formatTime(iso: string | Date): string {
  const p = localParts(new Date(iso));
  return `${pad(p.hour)}:${pad(p.minute)}`;
}

export function formatDateTime(iso: string | Date, now: Date = new Date()): string {
  const p = localParts(new Date(iso));
  const year = p.year === localParts(now).year ? "" : ` ${String(p.year)}`;
  return `${String(p.day)} ${monthName(p.month)}${year}, ${pad(p.hour)}:${pad(p.minute)}`;
}

export function formatDate(iso: string | Date): string {
  const p = localParts(new Date(iso));
  return `${String(p.day)} ${monthName(p.month)} ${String(p.year)}`;
}

export function formatShortDate(iso: string | Date, now: Date = new Date()): string {
  const p = localParts(new Date(iso));
  const year = p.year === localParts(now).year ? "" : ` ${String(p.year)}`;
  return `${String(p.day)} ${monthName(p.month)}${year}`;
}

export function formatRelative(iso: string | Date, now: Date = new Date()): string {
  const minutes = (now.getTime() - new Date(iso).getTime()) / 60_000;
  if (minutes < 1) return "Now";
  if (minutes < 60) return `${String(Math.round(minutes))} min ago`;
  if (minutes < 1440) return `${String(Math.round(minutes / 60))} h ago`;
  const days = Math.round(minutes / 1440);
  return days === 1 ? "Yesterday" : `${String(days)} d ago`;
}
